import type { QueryKey } from '@tanstack/react-query'
import { hashKey } from '@tanstack/react-query'

export interface RecordQueryScope {
  key: readonly unknown[]
  signal: AbortSignal
}

export function scopedRecordKey(key: QueryKey, scope: RecordQueryScope) {
  const index = key[1] === 'detail' ? 3 : 2
  return [
    ...key.slice(0, index),
    { workspaceSession: scope.key },
    ...key.slice(index),
  ] as const
}

export function isRecordQueryInScope(key: QueryKey, scope: RecordQueryScope) {
  const index = key[1] === 'detail' ? 3 : 2
  const tail = key[index] as { workspaceSession?: unknown } | undefined
  return (
    !scope.signal.aborted &&
    Array.isArray(tail?.workspaceSession) &&
    hashKey(tail.workspaceSession) === hashKey(scope.key)
  )
}
